function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.806 2.29a3.5 3.5 0 014.13 4.674l2.3 1.946a1.65 1.65 0 11-2.326 2.325L6.965 8.937a3.5 3.5 0 01-4.675-4.13.505.505 0 01.86-.216l1.522 1.653 1.149-.422.423-1.15-1.654-1.52a.505.505 0 01.216-.862z",
  fill: "currentColor"
});

var SvgService2 = function SvgService2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgService2;